import { Redirect, Route, Switch, useRouteMatch } from 'react-router';
import { Access } from './pages/Access';
import { Info } from './pages/Info';
import { Users } from './pages/Users';
import {
  userDetailsAccessPath,
  userDetailsAccessRoute,
  userDetailsInfoRoute,
  userDetailsRoute,
  UserParams,
  usersPath,
} from './routes';
import { UserPageWrapper } from './UserPageWrapper';

export const UsersRoutes = () => {
  const match = useRouteMatch<UserParams>(userDetailsRoute);

  const userId = match ? Number(match?.params.userId) : undefined;

  return (
    <Switch>
      <Route path={usersPath()} exact component={Users} />
      {userId ? (
        <Route path={userDetailsRoute}>
          <UserPageWrapper
            userId={userId}
            renderChildren={user => (
              <Switch>
                <Route path={userDetailsAccessRoute} exact>
                  <Access selectedUser={user} />
                </Route>
                <Route path={userDetailsInfoRoute} exact>
                  <Info selectedUser={user} />
                </Route>
                <Redirect to={userDetailsAccessPath(userId)} />
              </Switch>
            )}
          />
        </Route>
      ) : (
        <Redirect to={usersPath()} />
      )}
    </Switch>
  );
};
